import { useQuery } from '@apollo/client';
import { useState } from 'react';
import { GetFullSettings } from '../graphql/Query';
const _tags = new Map();
export const _activities = new Map();

export const useOptions = () => {
  const [tagsOptions, setTagsOptions] = useState([]);
  const { loading } = useQuery(GetFullSettings, {
    fetchPolicy: 'network-only',
    nextFetchPolicy: 'cache-first',
    notifyOnNetworkStatusChange: true,
    onCompleted: (data) => {
      const tags = data.getFullSettings.tags;
      Object.keys(tags).map((key) => {
        if (key !== '__typename') {
          tags[key].forEach((item) =>
            _tags.set(item._id, { _id: item._id, name: item.name })
          );
        }
      });
      setTagsOptions([..._tags.values()]);
    }
  });

  return {
    options: { tagsOptions, _activities },
    loading
  };
};
